export function calculateVisibleCount(
  containerWidth: number,
  buttonWidths: number[],
  arrowButtonWidth: number = 28,
  gap: number = 16,
  safetyBuffer: number = 20
): number {
  if (containerWidth <= 0 || buttonWidths.length === 0) {
    return 1
  }

  const arrowButtonsWidth = 2 * arrowButtonWidth
  const gapsBetweenArrows = 2 * gap
  const totalBuffer = safetyBuffer
  const availableWidth =
    containerWidth - totalBuffer - arrowButtonsWidth - gapsBetweenArrows

  if (availableWidth <= 0) {
    return 1
  }

  let count = 0
  let totalWidth = 0

  for (let i = 0; i < buttonWidths.length; i++) {
    const btnWidth = buttonWidths[i]
    const gapWidth = count > 0 ? gap : 0
    const widthWithGap = totalWidth + btnWidth + gapWidth

    if (widthWithGap <= availableWidth) {
      totalWidth = widthWithGap
      count++
    } else {
      break
    }
  }

  return Math.max(1, count)
}

export function calculateNavigationIndex(
  currentIndex: number,
  direction: 'left' | 'right',
  visibleCount: number,
  totalCount: number
): number {
  if (direction === 'left') {
    return Math.max(0, currentIndex - visibleCount)
  } else {
    return Math.min(totalCount - visibleCount, currentIndex + visibleCount)
  }
}
